/**
 * 🧱 Refactor BT Phase 3 — section « SectionProduitsCreer » de CreerBonTravailDialog.jsx : JSX déplacé TEL QUEL (ex-L1455-1524, dédenté de 10) ;
 * variables via `useBTForm()` (BTFormProvider enrichi par `extra`). DOM, data-testid, classes, textes inchangés.
 */
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Package, Plus, Trash2 } from 'lucide-react';
import { ProductSearchCombobox } from '../../ProductSearchCombobox';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useBTForm } from '../../BTFormContext';

export function SectionProduitsCreer() {
  const {
    addProduit,
    emplacementLabel,
    form,
    isExt,
    produits,
    removeProduit,
    type,
    updateProduit,
  } = useBTForm();
  return (
    <>
      {/* Produits */}
      <Card>
        <CardHeader>
          <div className="flex justify-between items-center">
            <CardTitle className="text-base flex items-center gap-2"><Package className="w-4 h-4" /> Produits</CardTitle>
            <Button type="button" size="sm" variant="outline" onClick={addProduit} data-testid="btn-add-produit"><Plus className="w-3 h-3 mr-1" /> Ajouter</Button>
          </div>
        </CardHeader>
        <CardContent>
          {form.produits_selectionnes.length === 0 ? (
            <p className="text-center text-gray-400 py-4 text-sm">Aucun produit ajouté</p>
          ) : (
            <div className="space-y-3">
              {form.produits_selectionnes.map((p, idx) => {
                const selectedProd = produits.find(pr => pr.id === p.produit_id);
                const finis = selectedProd?.finis_disponibles || [];
                return (
                  <div key={p.produit_id || `produit-${idx}`} className="border p-3 rounded-lg bg-gray-50 space-y-2">
                    <div className="grid grid-cols-12 gap-2 items-end">
                      <div className="col-span-4">
                        <Label className="text-xs">Produit</Label>
                        <ProductSearchCombobox
                          produits={produits}
                          value={p.produit_id}
                          onSelect={(prod) => updateProduit(idx, 'produit_id', prod.id)}
                          testId={`produit-search-${idx}`}
                        />
                      </div>
                      <div className="col-span-2">
                        <Label className="text-xs">Fini</Label>
                        <Select value={p.fini || undefined} onValueChange={(v) => updateProduit(idx, 'fini', v)}>
                          <SelectTrigger className="h-9"><SelectValue placeholder="Fini..." /></SelectTrigger>
                          <SelectContent>{finis.length > 0 ? finis.map(f => (<SelectItem key={f} value={f}>{f}</SelectItem>)) : <SelectItem value="-" disabled>Aucun fini</SelectItem>}</SelectContent>
                        </Select>
                      </div>
                      <div className="col-span-1">
                        <Label className="text-xs">Unité</Label>
                        <Select value={p.unite} onValueChange={(v) => updateProduit(idx, 'unite', v)}>
                          <SelectTrigger className="h-9"><SelectValue /></SelectTrigger>
                          <SelectContent>
                            <SelectItem value="pinte">Pinte</SelectItem>
                            <SelectItem value="gallon">Gallon</SelectItem>
                            <SelectItem value="chaudiere">Chaudière</SelectItem>
                          </SelectContent>
                        </Select>
                      </div>
                      <div className="col-span-1">
                        <Label className="text-xs">Qté</Label>
                        <Input className="h-9" type="number" min="1" value={p.quantite} onChange={(e) => updateProduit(idx, 'quantite', e.target.value)} />
                      </div>
                      <div className="col-span-2">
                        <Label className="text-xs">{emplacementLabel}</Label>
                        <Input className="h-9" value={p.emplacement} onChange={(e) => updateProduit(idx, 'emplacement', e.target.value)} placeholder={isExt ? 'Façade nord' : 'Cuisine'} />
                      </div>
                      <div className="col-span-1">
                        <Label className="text-xs">Couleur</Label>
                        <Input className="h-9" value={p.code_couleur || ''} onChange={(e) => updateProduit(idx, 'code_couleur', e.target.value)} placeholder="OC-17" data-testid={`produit-code-couleur-${idx}`} />
                      </div>
                      <div className="col-span-1 flex justify-center">
                        <Button type="button" variant="ghost" size="sm" onClick={() => removeProduit(idx)}><Trash2 className="w-4 h-4 text-red-500" /></Button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </CardContent>
      </Card>

    </>
  );
}
